var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome28X28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7597 13.42L26.0024 11.6627L14.58 0.240297C14.4262 0.0864064 14.2175 0 14 0C13.7824 0 13.5738 0.0864064 13.4199 0.240297L0.24027 13.42C-0.08009 13.7403 -0.08009 14.2597 0.24027 14.5801C0.56063 14.9004 1.07994 14.9004 1.40036 14.5801L1.75725 14.2232V27.1797C1.75725 27.6328 2.12453 28 2.57756 28H10.5438V18.3932C10.5438 17.9402 10.911 17.5729 11.3641 17.5729H16.6359C17.0889 17.5729 17.4562 17.9402 17.4562 18.3932V28H25.4225C25.8755 28 26.2428 27.6328 26.2428 27.1797V14.2231L26.5996 14.58C26.7599 14.7402 26.9698 14.8203 27.1797 14.8203C27.3896 14.8203 27.5996 14.7402 27.7597 14.58C28.0801 14.2597 28.0801 13.7403 27.7597 13.42Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome28X28);
export default __webpack_public_path__ + "static/media/home_28x28.77bfa7f903ebda03f709b1f049848c9a.svg";
export { ForwardRef as ReactComponent };